if (!AbortSignal.prototype.throwIfAborted) {
  AbortSignal.prototype.throwIfAborted = function () {
    if (this.aborted) {
      throw this.reason || new DOMException('This operation was aborted', 'AbortError')
    }
  }
}
